import { apiClient } from './axios';

export interface ClassifierConfig {
  id: string;
  name: string;
  prompt: string;
  model_name: string;
  temperature: number;
  taxonomy: Record<string, unknown>;
  taxonomy_version: string;
  is_default: boolean;
  inject_current_date: boolean;
  high_intent_emails: string[];
  created_at: string;
  updated_at: string;
}

export interface CreateClassifierConfigInput {
  name: string;
  prompt: string;
  model_name?: string;
  temperature?: number;
  taxonomy: Record<string, unknown>;
  taxonomy_version: string;
  is_default?: boolean;
  inject_current_date?: boolean;
  high_intent_emails?: string[];
}

export type UpdateClassifierConfigInput = Partial<CreateClassifierConfigInput>;

export const classifierConfigsApi = {
  list: async (): Promise<ClassifierConfig[]> => {
    const response = await apiClient.get<ClassifierConfig[]>('/classifier-configs');
    return response.data;
  },
  getById: async (id: string): Promise<ClassifierConfig> => {
    const response = await apiClient.get<ClassifierConfig>(`/classifier-configs/${id}`);
    return response.data;
  },
  create: async (data: CreateClassifierConfigInput): Promise<ClassifierConfig> => {
    const response = await apiClient.post<ClassifierConfig>('/classifier-configs', data);
    return response.data;
  },
  update: async (id: string, data: UpdateClassifierConfigInput): Promise<ClassifierConfig> => {
    const response = await apiClient.put<ClassifierConfig>(`/classifier-configs/${id}`, data);
    return response.data;
  },
  delete: async (id: string): Promise<void> => {
    await apiClient.delete(`/classifier-configs/${id}`);
  },
};
